import { axios } from '@/utils/request'

/**
 * 社区牛人
 * attention（粉丝数最多）
 * workNum (作品数量)
 * integral （积分）
 */
export function communityCattle(orderByType, pageNo, pageSize) {
    return axios({
        url: "/teaching/teachingWork/communityCattle",
        method: "get",
        params: { orderByType, pageNo, pageSize }
    })
}

/**
* 用户作品列表
* @param {*} userId
* @param {*} isCourseWork 
* @param {*} workTag 
* @param {*} scene 
* @param {*} pageNo 
* @param {*} pageSize 
* @param {*} courseId 
* @param {*} isShare 
* @param {*} pageNo 
* @param {*} pageSize 
*/
export function userWorkList(
    { userId,
        isCourseWork,
        workTag,
        workStatus,
        scene,
        courseId,
        isShare,
        orderBy,
        isAsc,
        pageNo = 1,
        pageSize = 99 }
) {
    return axios({
        url: "/teaching/teachingWork/userWorkList",
        method: "get",
        params: { userId, isCourseWork, workTag,workStatus, courseId, isShare, scene, orderBy, isAsc, pageNo, pageSize }
    });
}

/**
* 作品列表
* @param {*} isCourseWork 
* @param {*} workTag 
* @param {*} scene 
* @param {*} pageNo 
* @param {*} pageSize 
* @param {*} courseId 
* @param {*} isShare 
* @param {*} pageNo 
* @param {*} pageSize 
*/
export function mineWorkList(
    { isCourseWork,
        isAdditionWork,
        workTag,
        workStatus,
        scene,
        courseId,
        isShare,
        orderBy,
        isAsc,
        pageNo = 1,
        pageSize = 99 }
) {
    return axios({
        url: "/teaching/teachingWork/mineWorkList",
        method: "get",
        params: { isCourseWork, isAdditionWork, workTag, workStatus, courseId, isShare, scene, orderBy, isAsc, pageNo, pageSize }
    });
}


/**
 * 获取精选作品
 * @param {*} pageNo 
 * @param {*} pageSize 
 */
export function getWorkGreat(pageNo, pageSize) {
    return axios({
        url: "/teaching/teachingWork/choiceness?pageNo=" + pageNo + "&pageSize=" + pageSize,
        method: "get"
    })
}

/**
 * 作品排行榜(本周作品,年度作品)
 * cycle 周期（上周: preWeek 周:week  年: year  全部：''）
 * orderBy 排序（评分:score  点赞:star  时间：time）
 */
export function getWorkRank(cycle, orderBy, workName, codeType, workTag, pageNo, pageSize) {
    return axios({
        url: "/teaching/teachingWork/leaderboard",
        method: "get",
        params: {
            cycle, orderBy, workName, codeType, workTag, pageNo, pageSize
        }
    })
}

/**
 * 作品信息
 */
export function workInfo(workId) {
    return axios({
        url: "/teaching/teachingWork/studentWorkInfo",
        method: "get",
        params: { workId }
    });
}

/**
 * 删除我的作品
 */
export function delMyWork(workId) {
    return axios({
        url: "/teaching/teachingWork/delMyWork",
        method: "delete",
        params: { workId }
    });
}

/**
 * 点赞作品
 */
export function starWork(workId) {
    return axios({
        url: "/teaching/teachingWork/starWork?workId=" + workId,
        method: "get"
    })
}

/**
 * 是否点赞了作品
 */
export function isStarWork(workId) {
    return axios({
        url: "/teaching/teachingWork/isStarWork?workId=" + workId,
        method: "get"
    })
}

/**
 * 作品评分
 */
export function scoreWork(workId, score) {
    return axios({
        url: "/teaching/teachingWork/scoreWork",
        method: "get",
        params: {
            workId, score
        }
    })
}

/**
 * 收藏作品
 */
export function collectWork(workId) {
    return axios({
        url: "/teaching/teachingWork/collectWork?workId=" + workId,
        method: "get"
    })
}

/**
 * 是否收藏了作品
 * @param {}} workId 
 */
export function isCollectWork(workId) {
    return axios({
        url: "/teaching/teachingWork/isCollectWork?workId=" + workId,
        method: "get"
    })
}


/**
 * 作品评论列表
 * @param {} workId 
 */
export function workComments(workId, page) {
    return axios({
        url: "/teaching/comment/queryCommentBySourceId?id=" + workId,
        method: "get",
        params: { workId, page }
    });
}

/**
 * 作品评论/回复评论
 */
export function commentWork(sourceId, commentId, comment) {
    return axios({
        url: "/teaching/comment/saveComment",
        data: {
            sourceId: sourceId,
            commentId: commentId,
            comment: comment
        },
        method: "post"
    })
}

/**
 * 点赞评论
 */
export function starComment(commentId) {
    return axios({
        url: "/teaching/comment/starComment?commentId=" + commentId,
        method: "get"
    })
}

/**
* 获取用户信息
*/
export function getUserDetail(userId) {
    return axios({
        url: "/teaching/user/detailById?userId=" + userId,
        method: "get"
    })
}

/**
 * 关注用户
 * @param {*} followedUserId 
 */
export function attentionUser(followedUserId) {
    return axios({
        url: "/sys/user/attentionUser",
        method: "post",
        data: {
            followedUserId
        }
    })
}

/**
 * 是否关注
 * @param {}} workId 
 */
export function isAttentionUser(userId) {
    return axios({
        url: "/sys/user/isAttention?userId=" + userId,
        method: "get"
    })
}